import React from "react";
import LayersPanel from "./LayersPanel";
import LibraryPanel from "./LibraryPanel";
import MediaPanel from "./MediaPanel";
import { MODES } from "../../containers/TimelineEditor/NodeEditor";

const LeftSidebar = ({ 
  activeTab, 
  setActiveTab, 
  layersPanelProps,
  libraryItems,
  onLibraryDragStart,
  onLibraryDragEnd,

  leftListNewCustomisationItems,
  selectedFeatureId,
  setSelectedFeatureId,
  setSelectedFeatureNode,
  activateNode,
  activeNode,
  clearActiveNode,
  setTimelinePlayheadStep,
  forceUpdateComponentFunc,

  currentMode,
  setCurrentMode,

  campaignData,
}) => {
  return (
    <div className="timeline-editor-col library">
      <div className="sidebar-tabs">
        <button 
          className={`tab-button ${activeTab === 'layers' ? 'active' : ''}`}
          onClick={() => setActiveTab('layers')}
        >
          Layers
        </button>
        <button 
          className={`tab-button ${activeTab === 'library' ? 'active' : ''}`}
          onClick={() => setActiveTab('library')}
        >
          ICAST Library
        </button>
        <button 
          className={`tab-button ${activeTab === 'media' ? 'active' : ''}`}
          onClick={() => setActiveTab('media')}
        >
          Media
        </button>
      </div>

      {/* <div>
        <label className="stacking-toggle" style={{ marginTop: '12px' }}>
          <span className="toggle-label">Canvas Mode</span>
          <div className="toggle-switch">
            <input 
              type="checkbox" 
              checked={currentMode === MODES.CANVAS_EDITOR}
              onChange={(e) => setCurrentMode(e.target.checked ? MODES.CANVAS_EDITOR : MODES.FLOW_EDITOR)}
            />
            <span className="toggle-slider"></span>
          </div>
        </label>
      </div> */}
      
      <div className="tab-content">
        {activeTab === 'layers' && (
          <LayersPanel 
            {...layersPanelProps} 
            leftListNewCustomisationItems={leftListNewCustomisationItems}
            selectedFeatureId={selectedFeatureId}
            setSelectedFeatureId={setSelectedFeatureId}
            setSelectedFeatureNode={setSelectedFeatureNode}
            activateNode={activateNode}
            activeNode={activeNode}
            clearActiveNode={clearActiveNode}
            setTimelinePlayheadStep={setTimelinePlayheadStep}
            forceUpdateComponentFunc={forceUpdateComponentFunc}
            campaignData={campaignData}
          />
        )}
        
        {activeTab === 'library' && (
          <LibraryPanel 
            libraryItems={libraryItems}
            onDragStart={onLibraryDragStart}
            onDragEnd={onLibraryDragEnd}
          />
        )}
        
        {activeTab === 'media' && (
          <MediaPanel campaignData={campaignData} />
        )}
      </div>
    </div>
  );
};

export default LeftSidebar;
